(ns app.domain.acceptance.model
  (:require [app.domain.util :as du]
            [app.rich-text :as rich-text]
            [core.db.child-entity :as child]))

(defmulti acceptance-parent
  (fn [acceptance] (-> acceptance :entity/parent :entity/type)))

(defmethod acceptance-parent :default [acceptance]
  (:entity/parent acceptance))

(defmethod acceptance-parent :entity.type/attachment-version [acceptance]
  (-> acceptance :entity/parent :attachment/_versions))

(def ^{:arglists '([acceptance-target])} child-acceptances
  (child/child-entities-of-type-fn :entity.type/acceptance))

(defmulti acceptances-for-entity
  #_{:clj-kondo/ignore [:redundant-fn-wrapper]}
  (fn [entity] (:entity/type entity)))

(defmethod acceptances-for-entity :default
  [entity]
  (child-acceptances entity))

(defmethod acceptances-for-entity :entity.type/attachment
  [attachment]
  (->> attachment
       :attachment/versions
       (mapcat child-acceptances)))

(defn latest-acceptance [entity]
  (-> entity acceptances-for-entity du/latest-entity))


(def acceptance-states
  [;; created with a link to review, to be activated when a review result is given
   :acceptance.state/draft
   ;; valid
   :acceptance.state/active
   ;; used to clear out acceptances that were not handled by the time the permit was
   ;; issued
   :acceptance.state/archived])

(def acceptance-values
  [:acceptance.value/ok :acceptance.value/needs-changes])

(def acceptance-customer-values
  [:acceptance.customer-value/waiting-for-customer
   :acceptance.customer-value/updated-by-customer])

(defn value->signal [value require-review?]
  (case value
    :acceptance.value/ok            :process.signal/create-acceptance
    :acceptance.value/needs-changes (if require-review?
                                      :process.signal/create-acceptance-change-request
                                      :process.signal/create-acceptance-change-request-no-review)
    :process.signal/create-draft-acceptance))

(defmulti reviews-linked-to-acceptance-parent
  #_{:clj-kondo/ignore [:redundant-fn-wrapper]}
  (fn [acceptance-parent] (:entity/type acceptance-parent)))

(defmethod reviews-linked-to-acceptance-parent :entity.type/form
  [form]
  (->> form :review/_forms))

(defmethod reviews-linked-to-acceptance-parent :entity.type/attachment-version
  [attachment-version]
  (->> attachment-version
       :attachment/_versions
       (mapcat :review/_attachments)))

(defn has-value-fn [& values]
  {:pre [(every? (set acceptance-values) values)]}
  (fn [acceptance]
    (->> acceptance :acceptance/value (contains? (set values)))))

(defn has-customer-value-fn [& values]
  {:pre [(every? (set acceptance-customer-values) values)]}
  (fn [acceptance]
    (->> acceptance :acceptance/customer-value (contains? (set values)))))

(defn acceptance-can-be-responded-to? [acceptance]
  (and (= :acceptance.value/needs-changes (:acceptance/value acceptance))
       (= :acceptance.customer-value/waiting-for-customer (:acceptance/customer-value acceptance))
       (du/in-state? :acceptance.state/active acceptance)))

(defn blank-draft?
  "Draft acceptance with no value and no rich-text content, e.g. left behind by an opened item editor."
  [acceptance]
  (and (du/in-state? :acceptance.state/draft acceptance)
       (nil? (:acceptance/value acceptance))
       (rich-text/empty-rich-text? (:acceptance/text acceptance))))
